import { computed, onMounted, ref } from "vue"

export const useCurrentUser = () => {
  const userName = ref('Гость')
  const roleVisibleName = ref('Без роли')
  const roleName = ref('')
  const userId = ref<number | null>(null)
  const isSystemUser = ref(false);
  const systemPermissions = ref<string[]>([])
  
  const hydrateFromStorage = () => {
    if (!process.client) return
    const name = localStorage.getItem('user_name')
    const role = localStorage.getItem('role_visible_name')
    const roleSlug = localStorage.getItem('role_name')
    const id = Number(localStorage.getItem('user_id'))
    const isSystem = localStorage.getItem('is_system');
    const storedPermissions = localStorage.getItem('system_permissions')

    if (id) userId.value = id
    if (name) userName.value = name
    if (role) roleVisibleName.value = role
    else roleVisibleName.value = 'Без роли'
    if (roleSlug) roleName.value = roleSlug
    else roleName.value = ''
    if (isSystem === '1') {
      isSystemUser.value = true
    }
    try {
      const parsed = JSON.parse(storedPermissions || '[]')
      systemPermissions.value = Array.isArray(parsed) ? parsed.filter(item => typeof item === 'string') : []
    }
    catch {
      systemPermissions.value = []
    }
  }

  hydrateFromStorage()
  onMounted(() => {
    hydrateFromStorage()
  })

  const isAdmin = computed(() => isSystemUser.value || systemPermissions.value.includes('support.view'))

  function hasSystemPermission(permission: string) {
    return isSystemUser.value && systemPermissions.value.includes(permission)
  }

  function isAuthenticated() {
    return !!(localStorage.getItem('access_token') || sessionStorage.getItem('access_token'))
  }

  return { userId, userName, roleVisibleName, roleName, isSystemUser, isAdmin, systemPermissions, hasSystemPermission, isAuthenticated }
}
